import { render } from "./input.vue?vue&type=template&id=87712004&scoped=true"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"

import "./input.vue?vue&type=style&index=0&id=87712004&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87712004"]])

export default __exports__